import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Grid } from "@material-ui/core";
import { addPracticaDiscapacidad } from "../../../../actions/discapacidad/discapacidadActions";
import BuscadorPractica from "../../../turnos/coseguros/BuscadorPractica";
import { startAlerta } from "../../../../actions/ui/alertas";
import { finishSpinner, startSpinner } from "../../../../actions/ui/spinner";

export const IntegracionAddPractica = ({ postAgregar, auditoria, setHasChangesPractica }) => {
  const dispatch = useDispatch();

  const { solicitudSeleccionada = {} } = useSelector(
    (state) => state.discapacidad
  );

  const [codigoPractica, setCodigoPractica] = useState(null);
  const codigoPracticaRef = useRef(null);

  const onClickAgregarHandler = () => {    
    if (codigoPractica) {
      if(!Array.isArray(solicitudSeleccionada.practicas) || 
        solicitudSeleccionada.practicas?.filter(s => s.idCodNom ===codigoPractica.idCodNom).length === 0){
        const practicaAuth = {
          cant: 1,
          idCodNom: codigoPractica.idCodNom,
          practica: {
            codIntegrador: codigoPractica.codIntegrador,
            codNom: codigoPractica.codNom,
            modulo: codigoPractica.modulo,
            idNi: codigoPractica.idNi,
          },
        };
        dispatch(startSpinner());
        dispatch(addPracticaDiscapacidad(practicaAuth));
        dispatch(finishSpinner());
        codigoPracticaRef.current.resetValues();
        setCodigoPractica(null);
        if (!!postAgregar) postAgregar();
        if(!!auditoria && !!setHasChangesPractica)
          setHasChangesPractica();
      }else{
        dispatch(startAlerta("La practica que intenta agregar ya existe en la solicitud", "warning", "Atencion"));
      }
      
    } else {
      dispatch(startAlerta("Ingrese una practica", "warning", "Atencion"));
    }
  };

  return (
    <React.Fragment>
      <Grid
        container
        spacing={2}
        style={{ width: "60%", margin: "auto", marginTop: "1rem" }}
      >
        <Grid item xs={12}>
          <BuscadorPractica
            ref={codigoPracticaRef}
            cod={codigoPractica}
            label="Código Practica"
            fieldsDisabled={false}
            autorizacion={true}
            integracion={true}
            setCod={(val) => setCodigoPractica(val)}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ width: "60%", margin: "auto" }}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "1.5rem 0",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={onClickAgregarHandler}
          >
            Agregar +
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
